<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12">
         <router-link tag="div" to="/compromissos/ambientais">
          <div class="card text-center" :class="isActive('/compromissos/ambientais')">
            <div class="card-body">
              <i class="material-icons icone">assignment_turned_in</i>
              <p class="card-text">Documentos Ambientais</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>
import ls from 'local-storage';

export default {
  methods: {
    isActive(path) {
      const isIt = this.$route.fullPath.indexOf(path) > -1;
      return { 'bg-success': isIt, 'text-white': isIt };
    }
  }
};
</script>

<style scoped>
.icone {
  font-size: 50px;
  overflow: hidden;
}

.card {
  font-size: 10pt;
  cursor: pointer;
}

.col-4 {
  padding: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/app/compromissos/Home.vue